/// <amd-module name="TFS/Mobile/Components/SwitchToDesktop" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { setCookie } from "VSS/Platform/Util/Cookie";

import { Icon } from "VSSUI/Icon";
import { css } from "VSSUI/Util";

import { ISwitchToDesktopProps } from "TFS/Mobile/Components/SwitchToDesktop.Props";
import * as MobileResources from "TFS/Mobile/Resources";

class SwitchToDesktop extends VssComponent<ISwitchToDesktopProps> {
    public static componentType = "ms.vss-tfs-web.switchToDesktopCommand";

    public render(): JSX.Element {
        const { ariaLabel, className, iconClassName, iconProps, text = MobileResources.SwitchToDesktopMessage, textClassName } = this.props;
        return (
            <div aria-label={ariaLabel} className={css(className, "switch-to-desktop flex-row")} onClick={this.onClick} role="button">
                {iconProps && <Icon className={iconClassName} {...iconProps} />}
                <span className={textClassName}>{text}</span>
            </div>
        );
    }

    private onClick = () => {
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("MobileNavigation", "SwitchToDesktop", { newMobileSupport: true });

        setCookie("VstsBypassMobile", "");
        // @ts-ignore TypeScript 4.4 upgrade
        window.location.reload(true);
    };
}

VssComponent.register(SwitchToDesktop.componentType, SwitchToDesktop);
